import React, { useState } from "react";
import "./RoleAndPermission.css";
import { Button, Input, Table } from "antd";
import { LiaUserEditSolid } from "react-icons/lia";

const RoleAndPermission = () => {
  const [addNewrole, setAddNewrole] = useState(false);
  const [roleTitle, setRoleTitle] = useState("");

  const dataSource = [
    {
      key: "1",
      permissions: "Create & Delete a QA",
      user: <input type="checkbox" className="red-checkbox" checked={true} />,
      admin: <input type="checkbox" className="red-checkbox" checked={true} />,
      super_Admin: <input type="checkbox" className="red-checkbox" />,
    },
    {
      key: "2",
      permissions: "Create & Delete Reference Data",
      user: <input type="checkbox" className="red-checkbox" checked={true} />,
      admin: <input type="checkbox" className="red-checkbox" checked={true} />,
      super_Admin: (
        <input type="checkbox" className="red-checkbox" checked={true} />
      ),
    },
    {
      key: "Create & Delete Workspace",
      permissions: "John seena",
      user: <input type="checkbox" className="red-checkbox" checked={true} />,
      admin: <input type="checkbox" className="red-checkbox" checked={true} />,
      super_Admin: (
        <input type="checkbox" className="red-checkbox" checked={true} />
      ),
    },
    {
      key: "4",
      permissions: "Create & Delete Users",
      user: <input type="checkbox" className="red-checkbox" checked={true} />,
      admin: <input type="checkbox" className="red-checkbox" checked={true} />,
      super_Admin: (
        <input type="checkbox" className="red-checkbox" checked={true} />
      ),
    },
    {
      key: "5",
      permissions: "Access to 'Play' Tab",
      user: <input type="checkbox" className="red-checkbox" checked={true} />,
      admin: <input type="checkbox" className="red-checkbox" checked={true} />,
      super_Admin: (
        <input type="checkbox" className="red-checkbox" checked={true} />
      ),
    },
    {
      key: "6",
      permissions: "Can copy Template QAs",
      user: <input type="checkbox" className="red-checkbox" checked={true} />,
      admin: <input type="checkbox" className="red-checkbox" checked={true} />,
      super_Admin: (
        <input type="checkbox" className="red-checkbox" checked={true} />
      ),
    },
  ];

  const [columns, setColumns] = useState([
    {
      title: "Permissions",
      dataIndex: "permissions",
      key: "permissions",
    },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
    },
    {
      title: "Admin",
      dataIndex: "admin",
      key: "admin",
    },
    {
      title: "Super Admin",
      dataIndex: "super_Admin",
      key: "super_Admin",
    },
    {
      title: (
        <Input
          className="new-role-input-title"
          placeholder="Enter new role"
          value={roleTitle}
          onChange={(e) => handleRoleTitleChange(e.target.value)}
        />
      ),
      dataIndex: "newRole",
      key: "newRole",
    },
  ]);

  const handleRoleTitleChange = (newrole) => {
    setRoleTitle(newrole);
    setColumns([
      {
        title: newrole,
        dataIndex: "newRole",
        key: "newRole",
      },
    ]);
  };

  return (
    <div className="permission-container">
      <div className="add-role-div">
        <Button className="api-save " onClick={() => setAddNewrole(true)}>
          <LiaUserEditSolid />
          Add New Role
        </Button>
      </div>
      <div className="permission-table-div">
        <Table
          columns={columns}
          dataSource={dataSource}
          size="middle"
          className="mytable"
          pagination={false}
        />
      </div>
    </div>
  );
};

export default RoleAndPermission;
